import { render, staticRenderFns } from "./DeviceProducts.vue?vue&type=template&id=1b90e568"
import script from "./DeviceProducts.vue?vue&type=script&lang=ts"
export * from "./DeviceProducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports